// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"618":"00402a4e","55529":"9638a4e4","75077":"9638a4e4","75466":"88bd3c53","84747":"543335c9","88319":"b235569d","96387":"9638a4e4"}[chunkId] + ".chunk.css";
};